<template>
  <div class="sp-template">
    <div class="h-title">客户列表</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryCustomerForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="客户类型">
              <el-select v-model.lazy="queryCustomerForm.customerType" clearable>
                <el-option v-for="(d, i) in customerTypeList" :key="i" :label="d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model.lazy="queryCustomerForm.orgOwner" clearable filterable>
                <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="账号状态">
              <el-select v-model.lazy="queryCustomerForm.userStatus" clearable>
                <el-option v-for="(d, i) in userStatusList" :key="i" :label="d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="业务">
              <el-select v-model.lazy="queryCustomerForm.salesman" clearable filterable>
                <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客服">
              <el-select v-model.lazy="queryCustomerForm.customerServiceStaff" clearable filterable>
                <el-option v-for="(d, i) in customerServiceStaffs" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="flag" label="分公司">
              <el-select v-model.lazy="queryCustomerForm.companyId" clearable>
                <el-option v-for="(d, i) in companys" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

             <el-form-item  label="是否高风险">
                <el-checkbox v-model="queryCustomerForm.risk">高风险</el-checkbox>
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(50107)" size="small" type="primary" @click="onSubmit">搜 索</el-button>
            <el-button v-if="in_configs(50107)" size="small" @click="reset">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryCustomerForm.isDelete" @tab-click="onSubmit">
          <el-tab-pane v-if="in_configs(50105)" label="正常" name="正常"></el-tab-pane>
          <el-tab-pane v-if="in_configs(50106)" label="已删除" name="已删除"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(50109)" size="small"  @click="handleexport"> 在途货量导出</el-button>
          <el-button v-if="in_configs(50101)" size="small"  @click="handleEdit"> 新建客户</el-button>
          <el-button v-if="in_configs(50108)" size="small" @click="customersInfoExport()">导出客户信息</el-button>
        </div>
      </div>
      <el-table :data="customers" stripe border>
        <el-table-column prop="name" label="客户"></el-table-column>
        <el-table-column prop="username" label="账号"></el-table-column>
        <el-table-column prop="user" label="联系人"></el-table-column>
        <el-table-column prop="customerAttach.customerTypeName" label="客户类型"></el-table-column>
        <el-table-column prop="customerAttach.paymentTermsName" label="结算周期"></el-table-column>
        <el-table-column prop="customerAttach.credits" label="信用额度"></el-table-column>
        <el-table-column prop="debtBalance" label="欠款"></el-table-column>
        <el-table-column prop="customerAttach.orderReview" label="订单审核">
          <template slot-scope="scope">
            <i v-if="scope.row.customerAttach.orderReview">是</i>
            <i v-else>否</i>
          </template>
        </el-table-column>
        <el-table-column prop="customerAttach.salesmanName" label="业务员"></el-table-column>
        <el-table-column prop="customerAttach.customerServiceStaffName" label="客服"></el-table-column>
        <el-table-column label="分公司">
          <template slot-scope="scope">
            {{companyMap[scope.row.companyId]}}
          </template>
        </el-table-column>
        <el-table-column prop="createAt" label="注册时间"></el-table-column>
        <el-table-column prop="customerAttach.lastReceiptTime" label="最后到货日期"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{userStatusListMap[scope.row.userStatus]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="70px">
          <template slot-scope="scope">
            <el-dropdown trigger="click" >
							<el-button plain size="small">...</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item size="mini" type="text" v-if="in_configs(50102) && queryCustomerForm.isDelete==='正常'" @click.native="handleEdit(scope.$index, scope.row)">编辑</el-dropdown-item>
								<el-dropdown-item size="mini" type="text" v-if="in_configs(50103)" @click.native="handleLook(scope.$index, scope.row)">查看</el-dropdown-item>
								<el-dropdown-item size="mini" type="text" v-if="in_configs(50104) && queryCustomerForm.isDelete==='正常'" @click.native="handleDelete(scope.$index, scope.row)">删除</el-dropdown-item>
								<el-dropdown-item size="mini" type="text" v-if="queryCustomerForm.isDelete==='已删除'" @click.native="recoverCustomer(scope.$index, scope.row)">恢复账号</el-dropdown-item>
							</el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCustomerForm.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="queryCustomerForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <!-- 表单 -->
      <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
          <el-table-column property="test" label="日期" width="150"></el-table-column>
        </el-table>
      </el-dialog>

      <!-- Form -->
      <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
        <el-form :model="form" size="small">
          <el-form-item label="活动名称" :label-width="formLabelWidth">
            <el-input v-model.lazy="form.test" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
    <form action="" method="post" target="_blank" id="myform">
    </form>
  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      conditions: {
        product: "001"
      },
      customer: [{ name: "666", value: "001" }, { name: "777", value: "002" }],
      tableData: [{ test: "666" }],
      gridData: [{ test: "2016-05-02" }],
      dialogTableVisible: false,
      form: { test: "text" },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      multipleSelection: [],
      customerList: [],
      customers: [],
      total: 400,
      queryCustomerForm: {
        isDelete: "正常",
        orgOwner: "",
        customerType: "",
        salesman: "",
        customerServiceStaff: "",
        userStatus: "",
        currentPage: 1,
        pageSize: 10,
        export: 0,
        risk:false,
        companyId: ""
      },
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      customerServiceStaffs: [],
      salesmans: [],
      userStatusList: [
        { name: "账号未启用", value: "INITIALIZE" },
        { name: "审核未通过", value: "NOTPASSED" },
        { name: "审核已通过", value: "PASSED" }
      ],
      userStatusListMap: {
        INITIALIZE: "账号未启用",
        NOTPASSED: "审核未通过",
        PASSED: "审核已通过"
      },
      flag: true,
      companys: [],
      companyMap: {}
    };
  },
  components: {},
  created() {

    if (this.$route.query.orgOwner) {
      this.queryCustomerForm.orgOwner = this.$route.query.orgOwner
    }

    this.findByCustomerName();
    this.loadCustomerList();
    this.getCustomerType()
    setTimeout(() => {
      this.loadRoleList("业务员");
      this.loadRoleList("客服");
      this.queryCompany();
    }, 1000);
  },
  computed: {},
  methods: {
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    queryCompany(){
        let _this = this;
        this.$request1({
            method: 'get',
            url: '/system/company',
            params: {
              page:  1,
              pageSize: -1
            }
        })
        .then(response => {          
            _this.companys = response.data.data;
            _this.companys.forEach(a => {
                _this.companyMap[a.id] = a.name;
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    onSubmit() {
      this.loadCustomerList();
    },
    reset() {
      this.queryCustomerForm = {
        isDelete: "正常",
        orgOwner: "",
        customerType: "",
        salesman: "",
        customerServiceStaff: "",
        userStatus: "",
        currentPage: 1,
        pageSize: 10,
        export: 0
      }
      this.onSubmit()
    },
    //编辑
    handleEdit(index, row) {
      //this.$set(row, "look", false);
      row
        ? this.$router.push({
            path: "/customer/newcustomer",
            query: { data: row.customerAttach.orgOwner, look: false }
          })
        : this.$router.push("/customer/newcustomer");
      console.log(index, row);
    },
    //查看
    handleLook(index, row) {
      this.$set(row, "look", true);
      this.$router.push({
        path: "/customer/newcustomer",
        query: { data: row.customerAttach.orgOwner, look: true }
      });
      console.log(index, row);
    },
    //删除
    handleDelete(index, row) {
      let _this = this;

      _this
        .$confirm("此操作将删除该客户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _this.$request1
            .get(
              '/removecustomer/' + row.customerAttach.orgOwner + '',
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              console.log(res);
              if (res.data.success) {
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                _this.loadCustomerList();
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    recoverCustomer(index, row) {
      let _this = this;
      _this
        .$confirm(
          "此操作将恢复该客户以及绑定的登录账号,恢复后账号将可登录系统并下单,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          _this.$request1
            .get(
              '/recovercustomer/' + row.customerAttach.orgOwner + '',
              {
                withCredentials: true
              }
            )
            .then(function(res) {
              console.log(res);
              if (res.data.success) {
                _this.$message({
                  type: "success",
                  message: "恢复成功!"
                });
                _this.loadCustomerList();
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消恢复"
          });
        });
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.queryCustomerForm.pageSize = val;
      this.loadCustomerList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryCustomerForm.currentPage = val;
      this.loadCustomerList();
    },
    loadCustomerList() {
      let _this = this;
      let sendobj={}
      sendobj.isDelete= _this.queryCustomerForm.isDelete === "已删除";
      sendobj.orgOwner= _this.queryCustomerForm.orgOwner;
      sendobj.customerType= _this.queryCustomerForm.customerType;
      sendobj.salesman= _this.queryCustomerForm.salesman;
      sendobj.customerServiceStaff= _this.queryCustomerForm.customerServiceStaff;
      sendobj.userStatus= _this.queryCustomerForm.userStatus;
      sendobj.currentPage= _this.queryCustomerForm.currentPage;
      sendobj.pageSize= _this.queryCustomerForm.pageSize;
      sendobj.companyId = _this.queryCustomerForm.companyId;
      if(_this.queryCustomerForm.risk==true) {
        sendobj.risk=true 
      } 
      _this.$request1
        .post(
          '/querycustomer',
          sendobj,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          console.log(res);
          if (res.data.success) {
            _this.customers = res.data.data;
            _this.total = res.data.total;
            if (res.data.message == "false") {
              _this.flag = false;
            }
          } else {
            _this.customers = [];
            _this.total = 0;
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadRoleList(role) {
      let _this = this;
      _this.$request1
        .get(
          '/staffrole',
          {
            params: {
              role: role
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            if (role == "业务员") {
              _this.salesmans = res.data.data;
            } else if (role == "客服") {
              _this.customerServiceStaffs = res.data.data;
            }
          } else {
            _this.salesmans = [];
            _this.customerServiceStaffs = [];
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          console.log(res);
          if (res.data.success) {
            _this.customerList = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    customersInfoExport(){
      let _this = this;
      _this.queryCustomerForm.export=1;
      var params ={
            isDelete: _this.queryCustomerForm.isDelete === "已删除",
            orgOwner: _this.queryCustomerForm.orgOwner,
            customerType: _this.queryCustomerForm.customerType,
            salesman: _this.queryCustomerForm.salesman,
            customerServiceStaff: _this.queryCustomerForm.customerServiceStaff,
            userStatus: _this.queryCustomerForm.userStatus,
            currentPage: _this.queryCustomerForm.currentPage,
            pageSize: _this.queryCustomerForm.pageSize,
            export: _this.queryCustomerForm.export
      }

      this.$request1({
          url: '/querycustomer',
          method: 'post',
          data: params,
          responseType: 'blob'
        }).then(res => {
          _this.queryCustomerForm.export = 0

          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `customer_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })


      // var form = document.getElementById("myform")
      // var url = tmsSpringUrl +'/querycustomer';
      // form.setAttribute('action', url);
      // var fhtml = '';
      // for (var key in params){
      //     fhtml += '<input type="hidden" name="' + key + '" value="' + (params[key]==null?"":params[key]) + '" />';           
      // }
      // form.innerHTML = fhtml
      // form.submit();   
    },
    // 导出在途货量
    handleexport () {
     
       let _this = this;
            let sendobj={}
            sendobj.isDelete= _this.queryCustomerForm.isDelete === "已删除",
            sendobj.orgOwner= _this.queryCustomerForm.orgOwner,
            sendobj.customerType= _this.queryCustomerForm.customerType,
            sendobj.salesman= _this.queryCustomerForm.salesman,
            sendobj.customerServiceStaff= _this.queryCustomerForm.customerServiceStaff,
            sendobj.userStatus= _this.queryCustomerForm.userStatus,
            sendobj.currentPage= _this.queryCustomerForm.currentPage,
            sendobj.pageSize= _this.queryCustomerForm.pageSize
            if(_this.queryCustomerForm.risk==true) {
               sendobj.risk=true 
            }  
      var url = '/exportOnOrder';
      _this.$request1.post(url, 
        sendobj ,
        {responseType:'arraybuffer'},
      ).then((res)=>{
        if(res.data) {
        const link = document.createElement('a')
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', '在途货量.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        }
        else {
          this.$toast.error('导出失败')
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/customer/customerlist.vue